var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGtcStaking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8202 13.8133C21.2351 10.3984 26.7718 10.3984 30.1867 13.8133V13.8133V13.8133C33.6017 17.2283 33.6016 22.7649 30.1867 26.1798L22.5498 33.8167C19.1349 37.2317 13.5982 37.2317 10.1833 33.8167V33.8167V33.8167C6.76841 30.4018 6.76841 24.8651 10.1833 21.4502L17.8202 13.8133Z",
    fill: "#8C65F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1867 13.8201C33.6016 17.2351 33.6016 22.7717 30.1867 26.1867V26.1867V26.1867C26.7717 29.6016 21.2351 29.6016 17.8202 26.1867L14.0017 22.3682L10.1833 18.5498C6.76835 15.1348 6.76834 9.59817 10.1833 6.18325V6.18325V6.18325C13.5982 2.76833 19.1349 2.76833 22.5498 6.18325L26.3682 10.0017L30.1867 13.8201Z",
    fill: "#02E2AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6532,
    cy: 19.8842,
    r: 6.28956,
    transform: "rotate(45 23.6532 19.8842)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtcStaking);
export default __webpack_public_path__ + "static/media/gtc_staking.2cb0aca1.svg";
export { ForwardRef as ReactComponent };